import React, { ReactNode, createContext, useContext, useEffect } from "react";
import ReactGA from "react-ga4";

// Types for the context value
interface GAContextType {
  logEvent: (category: string, action: string, label?: string) => void;
}

// Create a context with the initial value and type assertion
export const GAContext = createContext<GAContextType | null>(null);

interface GAProviderProps {
  children: ReactNode;
  measurementId?: string
}


// Provider component
export const GAProvider = ({ children, measurementId }: GAProviderProps) => {
  // Function to log events
  const logEvent = (category: string, action: string, label?: string) => {
    (measurementId) &&
    ReactGA.event({
      category,
      action,
      label,
    });
  };

  useEffect( () => {
    if (!measurementId) {
      if (process.env.REACT_APP_TARGET_ENV !== "production") {
        console.log("GA Measurement ID not set");
      }
      return;
    }
    // public/index.html already loads gtag.js with crossorigin="anonymous"
    // and sets up window.gtag + dataLayer. ReactGA.event() routes through
    // window.gtag, so we don't need ReactGA.initialize() — and skipping it
    // avoids react-ga4 injecting a second gtag script tag without crossorigin
    // (which would cause window.onerror to capture masked "Script error." for
    // anything thrown by gtag's code). Only fall back to initialize() if for
    // some reason window.gtag isn't already set.
    if (typeof window !== "undefined" && !(window as any).gtag) {
      ReactGA.initialize(measurementId);
    }
  }, [measurementId]);

  // Provide the logEvent function to the context
  return (
    <GAContext.Provider value={{ logEvent }}>{children}</GAContext.Provider>
  );

};